import { ProductApiDto, SkuApiDto } from '@b2x/storefront-api-js-client/src';
import React from 'react';

import { Button } from './Button';
import { Col } from './Col';
import { appConfig } from './config';
import { AddToCartFieldsHelper } from './form/AddToCartForm';
import { Div, H6, P } from './HTMLElement';
import { Icon } from './Icon';
import { ImageSwitcher } from './ImageSwitcher';
import { PriceBlock } from './PriceBlock';
import { Row } from './Row';
import { UsePriceResult } from './usePrice';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface RecommendedCartProductTileBasicInfoProps {
  fieldsHelper: AddToCartFieldsHelper;
  onToggleShowMore(): void;
  priceHelper: UsePriceResult;
  product: ProductApiDto;
  showMore: boolean;
  sku?: SkuApiDto;
}

const RecommendedCartProductTileBasicInfo = ({
  onToggleShowMore,
  priceHelper,
  product,
  sku,
}: RecommendedCartProductTileBasicInfoProps) => {
  return (
    <Row>
      <Col size={''}>
        <Row>
          <Col size={'auto'}>
            <ImageSwitcher
              alt={product.name}
              aspectRatio={appConfig.productImageAspectRatio}
              fluid
              format={144}
              src={product.image?.src}
            />
          </Col>
          <Col size={''}>
            <H6 marginBottom={2}>
              <b>{product.name}</b>
            </H6>
            {sku && sku.name !== product.name && <P margin={0}>{sku.name}</P>}
          </Col>
          <Col size={{ md: 4, xl: 3, xs: 12 }}>
            <PriceBlock hiddenDiscountPercentage priceHelper={priceHelper} />
          </Col>
        </Row>
      </Col>
      <Col size={'auto'}>
        <Div textAlign={'end'}>
          <Button onClick={onToggleShowMore} type="button" variant="primary">
            {appConfig.icons?.cart && <Icon name={appConfig.icons.cart} size={25} />}
          </Button>
        </Div>
      </Col>
    </Row>
  );
};

export type RecommendedCartProductTileBasicInfoVariants = '';

const RecommendedCartProductTileBasicInfoController = React.memo(
  (props: PropsWithCustomComponent<RecommendedCartProductTileBasicInfoProps>) => (
    <VariantsController<RecommendedCartProductTileBasicInfoProps, RecommendedCartProductTileBasicInfoVariants>
      {...props}
      variantsControllerConfig={{
        defaultComponent: RecommendedCartProductTileBasicInfo,
        name: 'RecommendedCartProductTileBasicInfo',
      }}
    />
  ),
);
RecommendedCartProductTileBasicInfoController.displayName = 'RecommendedCartProductTileBasicInfoController';

export { RecommendedCartProductTileBasicInfoController as RecommendedCartProductTileBasicInfo };
